<template>
  <base-modal :modal-id="modalId" :modalSize="'lg'" :noCloseOnOutsideClick="true">
    <template v-slot:header>
      <h4 class="modal-title mb-0">{{ _T('My Location') }}</h4>
        <button type="button" class="btn btn-arrow" @click="$bvModal.hide(modalId)">
            <svg width="24" height="24" fill="none">
              <use xlink:href="#closeIcon" />
            </svg>
        </button>
    </template>
    <template v-slot:modal-body>
      <google-map ref="googleMap"></google-map>

      <div class="btns">
        <button
          type="button"
          :disabled="shouldButtonBeDisabled"
          class="btn btn-danger"
          data-dismiss="modal"
          @click.prevent="closeModal"
        >
          {{ _T('Select') }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/Modals/BaseModal'
import { mapGetters } from 'vuex'
import GoogleMap from '@/components/Blocks/GoogleMap'
import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'CustomerLocation',
  components: {
    BaseModal,
    GoogleMap,
  },
  data() {
    return {
      modalId: 'customer-location',
    }
  },
  computed: {
    ...mapGetters([
      '_T',
    ]),
    google: gmapApi,
    shouldButtonBeDisabled()
    {
      return this.$refs.googleMap ? this.$refs.googleMap.shouldButtonBeDisabled : false
    }
  },
  methods: {
    closeModal() {
      this.$refs.googleMap.applyAddress()
      this.$bvModal.hide(this.modalId)
    },
  },
}
</script>

<style lang="scss">
</style>
